import * as React from 'react';

import {RemoveButton} from '../../button/remove-button/remove-button';

import {getDisplayableSourceType} from './helpers';
import type {Source} from './types';

import styles from './source-tag.module.css';

type Props = {
    source: Source;
    onRemoveSource: () => any;
};

export function SourceTag(props: Props) {
    const {source, onRemoveSource} = props;

    const sourceType = getDisplayableSourceType(source.type);

    return (
        <div className={sourceType ? styles['source-tag'] : styles['source-tag--short']}>
            <div className={styles['text-container']}>
                <div>{source.name}</div>
                {sourceType ? <div>{sourceType}</div> : undefined}
            </div>
            <div className={styles['remove-button-container']}>
                <RemoveButton size={9} onClick={onRemoveSource} />
            </div>
        </div>
    );
}
